import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { ListUserGroupsDTO } from '../../dto'
import { store } from '../../store'

export const listUserGroups = async () => {

    let body: ListUserGroupsDTO
    let response: Response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/user-groups`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_USER_GROUPS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'LIST_USER_GROUPS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'LIST_USER_GROUPS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( ListUserGroupsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_USER_GROUPS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'LIST_USER_GROUPS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'LIST_USER_GROUPS_OK', userGroups: body.userGroups } )

}
